export default __webpack_public_path__ + "static/media/webcorp-build.b009476c.svg";